function convertToRadios(select, parent) {
  const $holder = $('<div class="radios-holder"></div>');
  const $parent = $(parent);
  $holder.append('<span class="hover-item"></span>');
  $(select).find("option").each(function() {
    const $this = $(this);
    const thisVal = $this.val();
    const thisText = $this.text();
    const $radio = $('<div class="radio__holder"></div>');
    const $input = $(`<input type="radio" name="${$(select).attr("id")}" value="${thisVal}" />`);
    const $label = $(`<label class="color--${thisVal}"></label>`);
    $radio.append($input).append($label);
    $holder.append($radio);
  });

  $holder.append('<span class="color-name"></span>');
  $parent.prepend($holder);
  $parent.find('input[type="radio"]').on("change", function() {
    const $this = $(this);
    const thisVal = $this.val();
    $(select).val(thisVal).trigger("change");
  });
  $parent.find('input[type="radio"]').eq(0).trigger("change");
}

module.exports = {
  convertToRadios
};



// WEBPACK FOOTER //
// ../assets/js/color-radios.js